/* eslint-disable */
import { mapState } from 'vuex';
import { DateFormatMixin } from '@/mixins/Booking/DateFormatMixin';
import { TimeFormatMixin } from '@/mixins/Booking/TimeFormatMixin';
import moment from 'moment-timezone'

export const BookingDateTimeMixin = {
    mixins: [DateFormatMixin, TimeFormatMixin],
    computed: {
        ...mapState('BookingUpload', [
          'startUtc'
        ]),
        ...mapState('TimeZone', [
            'selectedTimeZoneId'
        ]),
        formattedStartUtc() {
            if (!!this.startUtc) {
                return moment.utc(this.startUtc).clone().tz(this.selectedTimeZoneId)
            }
        },
        formattedStartDay(){ 
            return this.formattedStartUtc ? this.formattedStartUtc.format('dddd') : "";
        },
        formattedStartDate(){ 
            return this.formattedStartUtc ? this.formattedStartUtc.format(this.momentJSDateFormat) : "";
        },
        formattedStartTime() {
            return this.formattedStartUtc ? this.formattedStartUtc.format(this.momentJSTimeFormat) : "";
        }
    }
}
